import React, { Component } from 'react';
import './StationLogo.scss';
import helpers from '../../helpers';

class StationLogo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      href: '',
      channel: ''
    };
  }

  componentDidMount() {
    window.addEventListener('changeTheme', this.update.bind(this));
    this.update();
  }

  componentWillUnmount() {
    window.removeEventListener('changeTheme', this.update.bind(this));
  }

  update() {
    const { channel } = this.props;

    helpers.getChannelInfo(channel).then(
      channelInfo => {
        if (channelInfo.website) {
          this.setState({
            href: channelInfo.website,
            channel: channelInfo.name
          });
        } else {
          this.setState({
            href: '',
            channel: ''
          });
        }
      },
      error => {
        throw new Error(error);
      }
    );
  }

  render() {
    const { href, channel } = this.state;

    return (
      <div className="StationLogo">
        <a
          href={href}
          className="logo"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Link naar {channel} website</span>
        </a>
      </div>
    );
  }
}

export default StationLogo;
